<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h2>{{ questionTitle }}</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>You have the option to add a question for participants to answer before the survey begins.</h3>
              </div>
            </div>
          </div>
          <div>
            <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
              <fieldset>
                <div class="pure-g">
                  <div class="pure-u-1">
                    <RichTextEditor v-model="formModel.preOptionalQuestion" />
                  </div>
                </div>
                <button type="submit" class="hidden-submit"></button>
              </fieldset>
              <BigStudyNavigation></BigStudyNavigation>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  GET_NEXT_STUDY_STEP_ROUTE,
  UPDATE_STUDY,
  GET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION,
  SET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION,
} from '../../services/constants'
import RichTextEditor from "@/components/general/RichTextEditor"


export default {
  name: 'PreOptionalQuestion',
  components: { RichTextEditor },
  data () {
    return {
      formModel: null,
    }
  },
  computed: {
    ...mapGetters([
      GET_NEXT_STUDY_STEP_ROUTE,
      GET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION,
    ]),
    questionTitle () {
      return 'OPEN ENDED QUESTION'
    },
    isFormModelValid () {
      return true
    },
    placeholder () {
      return this[GET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION].placeholder
    }
  },
  methods: {
    handleSubmit () {
      if (this.isFormModelValid) {
        this.$store.commit(SET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION, this.formModel.preOptionalQuestion)
        this.$store.dispatch(UPDATE_STUDY).then(() => {
          this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
        })
      }
    },
    resetFormModel () {
      this.formModel = Object.assign({}, {
        preOptionalQuestion: this.$store.state.dataModule.inProgressStudy.preOptionalQuestion,
      })
    },
  },
  created () {
    this.resetFormModel()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/main";

.container {
  height: 100%;
}

section {
  height: 100%;
}

.layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}

.child {
  width: 100%;
  max-width: 500px;
  margin: 1em;
}

h2 {
  text-align: center;
  color: $red-2;
}

h3 {
  color: $cyan-blue-3;
}

.pure-form textarea {
  box-shadow: none;
  width: 100%;
  color: $cyan-blue-3;
  border-color: $cyan-blue-3;

  &:focus {
    border-color: $cyan-blue-1;
  }
  &:placeholder-shown {
    color: $gray-3;
  }
  &:-ms-input-placeholder {
    color: $gray-3;
  }
}

.question-title {
  font-size: 0.83em;
  font-weight: bold;
  color: $cyan-blue-3;
}

::placeholder {
  color: $gray-3;
  opacity: 1;
}
</style>
